import type { NodePropertySchema } from '../../../types/node-properties';

/**
 * Execute Workflow Tool Node Schema
 * Property configuration for the Execute Workflow Tool node
 */
const schema: NodePropertySchema = {
  nodeType: 'execute-workflow-tool',
  version: '1.0.0',
  properties: [
    {
      key: 'notice',
      label: 'Info',
      type: 'notice',
      default: '',
      description: 'This node allows AI Agents to execute workflows as tools. Configure a clear description to help the AI understand when to invoke this workflow.',
    },
    {
      key: 'workflowId',
      label: 'Workflow',
      type: 'string',
      required: true,
      placeholder: 'Select a workflow',
      description: 'Select a workflow to execute. The workflow should have a Workflow Trigger node.',
      customComponent: 'WorkflowSelector',
    },
    {
      key: 'toolName',
      label: 'Tool Name',
      type: 'string',
      required: false,
      placeholder: 'Auto-generated if empty',
      description: 'Custom name for the tool (snake_case). The AI Agent will see this name.',
    },
    {
      key: 'toolDescription',
      label: 'Tool Description',
      type: 'text',
      required: false,
      placeholder: 'Describe what this workflow does and when the AI should use it',
      description: 'Description shown to the AI Agent. Be specific about inputs and expected behavior.',
      typeOptions: {
        rows: 4,
      },
    },
    {
      key: 'inputSchema',
      label: 'Input Schema',
      type: 'json',
      default: '{}',
      placeholder: '{ "type": "object", "properties": { ... } }',
      description: 'JSON Schema defining the input parameters the AI can provide.',
      displayOptions: {
        show: {
          advancedOptions: [true],
        },
      },
    },
    {
      key: 'advancedOptions',
      label: 'Show Advanced Options',
      type: 'boolean',
      default: false,
      description: 'Show advanced configuration options.',
    },
  ],
};

export default schema;
